import {
  SET
} from 'reducer/types/prefix'

export const SUCCESS_DIALOG = 'SUCCESS_DIALOG'

export const SET_SUCCESS_DIALOG_SHOW = `${SET}${SUCCESS_DIALOG}_SHOW`